import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { ExchangeRates } from "./exchange-rates.entity";
import { Between, Repository } from "typeorm";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { ExchangeIdReq, ExchangeRatesRequest, ExchangeRatesResponseModel } from "@gtpl/shared-models/masters";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { Currencies } from "../currencies/currencies.entity";

@Injectable()
export class ExchangeRatesService {
    constructor(
        @InjectRepository(ExchangeRates)
        private exchangeRepository: Repository<ExchangeRates>,
        private logService:LogsService,
        
    ) { }

    async createExchangeRate(req:ExchangeRatesRequest,isUpdate: boolean):Promise<ExchangeRatesResponseModel>{
        try{
            console.log(req,'service req')
            if(!isUpdate){
                const existingData = await this.exchangeRepository.findOne({ currencyInfo: { currencyId: req.currencyId }, exchangeRate: req.exchangeRate })
                if (existingData) {
                    throw new Error('Currency with the same exchange rate already exists.');
                }
            }
            const entityData = new ExchangeRates()
            entityData.effectiveFrom = req.effectiveFrom
            entityData.exchangeRate = req.exchangeRate
            const currencyData = new Currencies()
            currencyData.currencyId = req.currencyId
            entityData.currencyInfo = currencyData
            entityData.createdUser = req.createdUser
            entityData.updatedUser = req.updatedUser
            console.log(entityData,'service entityData')
            const saveData = await this.exchangeRepository.save(entityData)
            console.log(saveData,'service saveData')
            const dataInfo = new ExchangeRatesRequest(saveData.id,saveData.effectiveFrom,saveData.createdUser,saveData.updatedUser, saveData.exchangeRate,saveData.currencyInfo.currencyId)
            return new ExchangeRatesResponseModel(true, 1, 'Exchange Rate created successfully', [dataInfo])
        }catch(err){
            throw(err)
        }
    }

    async activateDeactivateExchange(req:ExchangeRatesRequest): Promise<ExchangeRatesResponseModel>{
        try{
            console.log(req,'yyyyyyyyyyyyyy')
            const data = await this.exchangeRepository.findOne({where:{id:req.id}})
            console.log(data,'===================')
            const message = data.isActive === req.isActive ? `already ${req.isActive ? 'activated' : 'deactivated'}` : `successfully ${req.isActive ? 'activated' : 'deactivated'}`
            console.log(message,'message')
            const response = data.isActive === req.isActive ? req.isActive ? 10112 : 10115 : req.isActive ? 10114 : 10115;
            console.log(response,'response')
            await this.exchangeRepository.update({ id: req.id }, { isActive: req.isActive, updatedUser: req.updatedUser });

            return new ExchangeRatesResponseModel(true,response,`Exchange Rate is ${message}`)

        }catch(err){
            throw(err)
        }
    }

    async getAllExchangeRates(req?: ExchangeIdReq):Promise<ExchangeRatesResponseModel>{
        try{
            let whereCondition = {};
            if (req && req.fromDate && req.toDate) {
                whereCondition = { effectiveFrom: Between(req.fromDate, req.toDate) };
            }
            const data = await this.exchangeRepository.find({order:{exchangeRate:'ASC'},relations:['currencyInfo'], where: whereCondition})
            if(data.length > 0){
                const requestData = data.map(item => new ExchangeRatesRequest(item.id, item.effectiveFrom, item.createdUser, item.updatedUser, item.exchangeRate, item.currencyInfo.currencyId, item.currencyInfo.currencyName, item.isActive))
                return new ExchangeRatesResponseModel(true, 1, 'Data retrieved successfully',requestData)
            } else{
                return new ExchangeRatesResponseModel(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getAllActiveExchangeRates(): Promise<ExchangeRatesResponseModel>{
        try{
            const data = await this.exchangeRepository.find({order:{exchangeRate:'ASC'},relations:['currencyInfo'],where:{isActive: true}})
            if(data.length > 0){
                const requestData = data.map(item=> new ExchangeRatesRequest(item.id,item.effectiveFrom,item.createdUser,item.updatedUser,item.exchangeRate,item.currencyInfo.currencyId,item.currencyInfo.currencyName,item.isActive))
                return new ExchangeRatesResponseModel(true, 1, 'Data retrieved successfully', requestData)
            }else{
                return new ExchangeRatesResponseModel(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    
     
}